<template>
    <div
        class="w-100 cursor-pointer transition-all px-10 py-2 selector rounded-pill primary--border d-flex flex-row justify-space-between align-center primary--text position-relative"
    >
        <v-icon class="primary--text mx-3">{{ 'mdi-volume-off' }}</v-icon>
        <div class="d-flex w-100 align-center">
            <slot></slot>
        </div>
        <v-icon class="primary--text mx-3">{{ 'mdi-volume-high' }}</v-icon>
    </div>
</template>
<script>
export default {}
</script>

<style>
.primary--border {
    border: 1.5px solid #514773 !important;
}
.selector {
    background: white !important;
}
</style>
